import type { TerrainType } from '../turn/types';

/**
 * Shared softer terrain palette used by TurnGameScene's tile fill and the
 * editor's preview canvas. Forest/mountain/road share the plains base
 * because their distinguishing icons are drawn as overlays on top; bridge
 * shares the water base for the same reason (road sprite on top).
 */
export const TERRAIN_COLORS: Record<TerrainType, number> = {
  plains: 0x3e561d,
  forest: 0x3e561d,
  mountain: 0x3e561d,
  road: 0x3e561d,
  water: 0x354f66,
  bridge: 0x354f66,
  /**
   * Slightly lighter, more saturated than water — coast tiles read as
   * "shallow / amphibious" against the dark sea so ships and infantry
   * don't visually disappear there.
   */
  coast: 0x4a708a,
};
